import type { GetServerSideProps, NextPage } from 'next';

import MapWithMarkers from '../../components/layout/MapWithMarkers';
import PageTitle from '../../components/layout/PageTitle';
import dealersService from '../../services/dealersService';
import styles from '../../styles/DealerPage.module.scss';
import type DealerType from '../../types/DealerType';

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const slug = String(query.slug);

  const { dealer } = await dealersService.getDealer(slug);
  return {
    props: { dealer },
  };
};

interface Props {
  dealer: DealerType;
}

const DealerPage: NextPage<Props> = ({ dealer }) => {
  const center = {
    lat: dealer.latitude,
    lng: dealer.longitude,
  };

  return (
    <div className={styles.dealerPage}>
      <PageTitle
        title={dealer.name}
        breadcrumbs={[
          ['Strona główna', '/'],
          ['Dystrybutorzy', '/dystrybutorzy'],
          dealer.name,
        ]}
      />

      <div className="container">
        <div className={styles.dealerLayout}>
          <div className={styles.dealerMap}>
            <MapWithMarkers center={center} markers={[center]} zoom={12} />
          </div>
          <div className={styles.dealerText}>
            <h3 className={styles.dealerName}>{dealer.name}</h3>

            <div className={styles.dealerDescription}>{dealer.description}</div>

            <div className={styles.dealerDetail}>
              <h4>Adres:</h4>
              {dealer.address}
            </div>
            <div className={styles.dealerDetail}>
              <h4>Kontakt:</h4>
              {dealer.phone_number && (
                <div className={styles.dealerPhone}>{dealer.phone_number}</div>
              )}
              {dealer.email && (
                <div className={styles.dealerEmail}>{dealer.email}</div>
              )}
              {dealer.website && (
                <div className={styles.dealerWebsite}>{dealer.website}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealerPage;
